import { useTranslation } from '@thoughtspot/i18n';
import {
    PropertyMap,
    UserAction,
    userActionTypeEnum,
} from '@thoughtspot/metrics';
import {
    Alert,
    BannerAlertType,
} from '@thoughtspot/radiant-react/widgets/alert';
import React, { useState } from 'react';
import styles from './trial-info.module.scss';

export interface SpotterOnboardingHomeTabProps {
    collectEvent: (userAction: UserAction, property: PropertyMap) => void;
}
export const SpotterOnboardingHomeTab: React.FC<SpotterOnboardingHomeTabProps> = ({
    collectEvent,
}) => {
    const { t } = useTranslation();

    const [visible, setIsVisible] = useState(
        localStorage.getItem('isOpenedFromSpotter') === 'true' || false,
    );

    const handleBackToSpotterClick = () => {
        collectEvent(
            new UserAction(
                userActionTypeEnum.RESUME_SPOTTER_ONBOARDING_CTA_CLICKED,
            ),
            {},
        );
        if (window?.opener && window?.opener?.name) {
            window.open('', window.opener.name);
        }
    };

    const handleClose = () => {
        if (localStorage.getItem('isOpenedFromSpotter') === 'true') {
            localStorage.removeItem('isOpenedFromSpotter');
            setIsVisible(false);
        }
    };

    const onBackToSpotterAction = {
        label: t('edge.onboarding.spotter.returnFromHome'),
        onClick: () => {
            handleBackToSpotterClick();
        },
    };

    return (
        <Alert.Banner
            isVisible={visible}
            type={BannerAlertType.INFO}
            message={t('edge.onboarding.spotter.anotherTab')}
            primaryAction={onBackToSpotterAction}
            onClose={handleClose}
            global
            data-testid="spotter-onboarding-home-banner"
            className={styles.spotterOnboardingHomeBanner}
        />
    );
};
